import React from "react"

import { getFormattedMessage } from "../../components/shared_components_registration"

export default function RequiredFieldWarning(props) {
  const { warning } = props

  return (
    <p className={"warning-message"} style={{ display: warning ? "block" : "none", marginLeft: "2px" }}>
      {getFormattedMessage("general.warning.requiredFormField", "* Required Field")}
    </p>
  )
}
